<app-trix-text [text]="ce.data.text"></app-trix-text>
